<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :style="style"
    fill="currentColor"
    focusable="false"
  >
    <use :href="`${portalSvgUrl}#${icon}`" :xlink:href="`${portalSvgUrl}#${icon}`" />
  </svg>
</template>

<script lang="ts" setup>
import portalSvgUrl from '@/assets/images/portal.svg'

defineProps({
  icon: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    required: false,
    default: '0.875em',
  },
  height: {
    type: String,
    required: false,
    default: '0.875em',
  },
  style: {
    type: Object,
    required: false,
    default: () => ({}),
  },
})
</script>
